type Props = { title: string; description: string };

export default function CrmSectionPlaceholder({ title, description }: Props) {
  return (
    <div className="bg-white border border-stone rounded-xl p-6 shadow-sm">
      <h2 className="text-lg font-semibold">{title}</h2>
      <p className="mt-2 text-concrete">{description}</p>
    </div>
  );
}
